// import { useAlgolia } from './useAlgolia';
// const { index } = useAlgolia();
import useMeili from './useMeili';
const { index } = useMeili();

async function useProduct(key: string): Promise<object | null> {
    const results = await index.search('', {
        attributesToHighlight: [],
        filter: `product_key = '${key}'`,
        hitsPerPage: 1,
    });

    return results.hits[0] || null;
}

export default useProduct;
